import React from 'react'
import {
  Button,
  Col,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap'
import Swal from 'sweetalert2'

import { DatePicker, Select, } from '../revel-strap'

import { handleFunc, numberFunc, dateFunc, } from '../../utils'

import {
  BookBankModel,
  BankModel,
  ChequePayModel,
  SupplierModel,
} from '../../models'

const bank_model = new BankModel()
const book_bank_model = new BookBankModel()
const cheque_pay_model = new ChequePayModel()
const supplier_model = new SupplierModel()

class ChequePayModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      cheque_validate: {
        status: '',
        class: '',
        text: '',
      },
      cheque_action: 'add',
      cheque_pay_code: '',
      bank_code: '',
      book_bank_code: '',
      supplier_code: '',
      supplier_name: '',
      cheque_pay_number: '',
      cheque_pay_date: new Date(),
      cheque_pay_write_date: new Date(),
      cheque_pay_price: '',
      cheque_pay_balance: '',
      cheque_pay_remark: '',
      cheque_pay_crossed: "0",
      cheque_pay_shipping: "0",
      banks: [],
      book_banks: [],
      suppliers: [],
      cheque_pay_shipping_date: new Date(),
      cheque_pay_shipping_number: '',
      cheque_pay_shipping_bank_date: new Date(),
      cheque_pay_shipping_bank_code: '',
      cheque_pay_shipping_bank_total: '',
      cheque_pay_shipping_value: '',
    }
  }

  componentDidMount() {
    this._fetchData()
  }

  componentDidUpdate(props_old) {
    if (!props_old.show && this.props.show) {
      this._onPropsUpdate()
    }
  }

  _fetchData = async () => {
    const banks = await bank_model.getBankBy()
    const book_banks = await book_bank_model.getBookBankBy()
    const suppliers = await supplier_model.getSupplierBy()

    this.setState({
      banks: banks.data,
      book_banks: book_banks.data,
      suppliers: suppliers.data,
    })
  }

  _onPropsUpdate = async () => {
    const { code, supplier_code, } = this.props

    if (code) {
      const cheque_pay = await cheque_pay_model.getChequePayByCode({ cheque_pay_code: code })

      if (cheque_pay.require === false) {
        Swal.fire({ title: "ข้อผิดพลาด !", text: 'ไม่สามารถโหลดข้อมูล', icon: "error", })
        this._handleClose()
      } else if (cheque_pay.data.length === 0) {
        Swal.fire({ title: "ไม่พบรายการนี้ในระบบ !", text: code, icon: "warning", })
        this._handleClose()
      } else {
        const {
          cheque_pay_code,
          supplier_code,
          bank_code,
          book_bank_code,
          supplier_name,
          cheque_pay_number,
          cheque_pay_date,
          cheque_pay_write_date,
          cheque_pay_price,
          cheque_pay_balance,
          cheque_pay_remark,
          cheque_pay_crossed,
          cheque_pay_shipping,
          cheque_pay_shipping_date,
          cheque_pay_shipping_number,
          cheque_pay_shipping_bank_date,
          cheque_pay_shipping_bank_code,
          cheque_pay_shipping_bank_total,
          cheque_pay_shipping_value,
        } = cheque_pay.data[0]

        this.setState({
          cheque_validate: { status: 'VALID', class: '', text: '', },
          cheque_action: 'edit',
          cheque_pay_code,
          supplier_code,
          bank_code,
          book_bank_code,
          supplier_name,
          cheque_pay_number,
          cheque_pay_date: dateFunc.toDate(cheque_pay_date),
          cheque_pay_write_date: dateFunc.toDate(cheque_pay_write_date),
          cheque_pay_price: numberFunc.decimalFix(cheque_pay_price, 2),
          cheque_pay_balance: numberFunc.decimalFix(cheque_pay_balance, 2),
          cheque_pay_remark,
          cheque_pay_crossed,
          cheque_pay_shipping,
          cheque_pay_shipping_date,
          cheque_pay_shipping_number,
          cheque_pay_shipping_bank_date,
          cheque_pay_shipping_bank_code,
          cheque_pay_shipping_bank_total,
          cheque_pay_shipping_value,
        })
      }
    } else {
      const now = new Date()
      const Last_code = await cheque_pay_model.generateChequePayLastCode({
        code: `QP${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}`,
        digit: 3,
      })

      this.setState({
        cheque_action: 'add',
        cheque_pay_code: Last_code.data,
        supplier_code: supplier_code || '',
      })
    }
  }

  _handleSave = async () => {
    if (this._checkSubmit()) {
      const { bank_name, } = this.state.banks.find(item => item.bank_code === this.state.bank_code)

      const data = {
        cheque_pay_code: this.state.cheque_pay_code,
        supplier_code: this.state.supplier_code,
        bank_code: this.state.bank_code,
        book_bank_code: this.state.book_bank_code,
        bank_name: bank_name || '',
        company_branch_code: this.props.company_branch_code,
        supplier_name: this.state.supplier_name,
        cheque_pay_number: this.state.cheque_pay_number,
        cheque_pay_date: dateFunc.toFormat(this.state.cheque_pay_date, 'YYYY-MM-DD'),
        cheque_pay_write_date: dateFunc.toFormat(this.state.cheque_pay_write_date, 'YYYY-MM-DD'),
        cheque_pay_price: numberFunc.toFloat(this.state.cheque_pay_price),
        cheque_pay_remark: this.state.cheque_pay_remark,
        cheque_pay_crossed: this.state.cheque_pay_crossed,
        cheque_pay_shipping: this.state.cheque_pay_shipping,
        cheque_pay_shipping_date: dateFunc.toFormat(this.state.cheque_pay_shipping_date, 'YYYY-MM-DD'),
        cheque_pay_shipping_number: this.state.cheque_pay_shipping_number,
        cheque_pay_shipping_bank_date: dateFunc.toFormat(this.state.cheque_pay_shipping_bank_date, 'YYYY-MM-DD HH:mm'),
        cheque_pay_shipping_bank_code: this.state.cheque_pay_shipping_bank_code,
        cheque_pay_shipping_bank_total: this.state.cheque_pay_shipping_bank_total,
        cheque_pay_shipping_value: this.state.cheque_pay_shipping_value,
        addby: this.props.user_code,
        updateby: this.props.user_code,
      }

      const res = this.state.cheque_action === 'edit' ? await cheque_pay_model.updateChequePayBy(data) : await cheque_pay_model.insertChequePay(data)

      if (res.require) {
        const cheque_pay = await cheque_pay_model.getChequePayByCode({ cheque_pay_code: this.state.cheque_pay_code })

        if (cheque_pay.require === false) {
          Swal.fire({ title: "ข้อผิดพลาด !", text: 'ไม่สามารถโหลดข้อมูล', icon: "error", })
        } else if (cheque_pay.data.length === 0) {
          Swal.fire({ title: "ไม่พบรายการนี้ในระบบ !", text: this.state.cheque_pay_code, icon: "warning", })
        } else {
          this.props.onSave(cheque_pay.data[0])
        }
      } else {
        Swal.fire({ title: "เกิดข้อผิดพลาด !", text: "ไม่สามารถดำเนินการได้ !", icon: "error", })
      }
    }
  }

  _checkSubmit() {
    // if (this.state.cheque_validate.status !== 'VALID') {
    //   Swal.fire({ text: this.state.cheque_validate.text, icon: "warning", })
    //   return false
    // } else if (this.state.supplier_code === '') {
    //   Swal.fire({ text: "กรุณาระบุผู้รับเช็ค / Please input Supplier", icon: "warning", })
    //   return false
    if (this.state.supplier_name === '') {
      Swal.fire({ text: "กรุณาระบุผู้รับเช็ค / Please input Supplier", icon: "warning", })
      return false
    } else if (this.state.bank_code === '') {
      Swal.fire({ text: "กรุณาระบุธนาคาร / Please input Bank", icon: "warning", })
      return false
    } else if (this.state.book_bank_code === '') {
      Swal.fire({ text: "กรุณาระบุจ่ายจากบัญชี / Please input Account", icon: "warning", })
      return false
    } else if (this.state.cheque_pay_price.trim() === '') {
      Swal.fire({ text: "กรุณาระบุจำนวนเงิน / Please input Price", icon: "warning", })
      return false
    } else {
      return true
    }
  }

  _resetState = async () => {
    const now = new Date()
    const Last_code = await cheque_pay_model.generateChequePayLastCode({
      code: `QP${now.getFullYear()}${(now.getMonth() + 1).toString().padStart(2, '0')}`,
      digit: 3,
    })

    this.setState({
      cheque_validate: { status: 'VALID', class: '', text: '', },
      cheque_pay_code: Last_code.data,
      cheque_action: 'add',
      bank_code: '',
      book_bank_code: '',
      supplier_code: '',
      supplier_name: '',
      cheque_pay_number: '',
      cheque_pay_date: new Date(),
      cheque_pay_write_date: new Date(),
      cheque_pay_price: '',
      cheque_pay_balance: '',
      cheque_pay_remark: '',
      cheque_pay_crossed: "0",
      cheque_pay_shipping: "0",
      cheque_pay_shipping_date: new Date(),
      cheque_pay_shipping_number: '',
      cheque_pay_shipping_bank_date: new Date(),
      cheque_pay_shipping_bank_code: '',
      cheque_pay_shipping_bank_total: '',
      cheque_pay_shipping_value: '',
    })
  }

  _checkChequePayNumberBy = async () => {
    const cheque_number = this.state.cheque_pay_number.trim()

    if (cheque_number.length && this.state.bank_code) {
      const cheque_pay = await cheque_pay_model.checkChequePayNumberBy({
        cheque_pay_code: this.state.cheque_pay_code,
        cheque_pay_number: cheque_number,
        bank_code: this.state.bank_code,
      })

      if (cheque_pay.data.length) {
        const {
          cheque_pay_code,
          bank_code,
          book_bank_code,
          supplier_code,
          supplier_name,
          cheque_pay_number,
          cheque_pay_date,
          cheque_pay_write_date,
          cheque_pay_price,
          cheque_pay_balance,
          cheque_pay_remark,
          cheque_pay_crossed,
          cheque_pay_shipping,
          cheque_pay_shipping_date,
          cheque_pay_shipping_number,
          cheque_pay_shipping_bank_date,
          cheque_pay_shipping_bank_code,
          cheque_pay_shipping_bank_total,
          cheque_pay_shipping_value,
        } = cheque_pay.data[0]

        const { bank_name, } = this.state.banks.find(item => item.bank_code === bank_code)

        let result = await Swal.fire({
          title: "มีรายการนี้แล้ว แก้ไขรายการเดิม ?",
          text: (`
            ${cheque_pay_number} (${bank_name})
            วันที่เช็ค : ${dateFunc.toFormat(cheque_pay_date, 'DD/MM/YYYY')}
            จำนวนเงิน : ${numberFunc.decimalFix(cheque_pay_price, 2)}
          `),
          icon: "warning",
          showCancelButton: true,
        })

        if (result.value) {
          this.setState({
            cheque_validate: { status: 'VALID', class: '', text: '', },
            cheque_action: 'edit',
            cheque_pay_code,
            bank_code,
            book_bank_code,
            supplier_code,
            supplier_name,
            cheque_pay_number,
            cheque_pay_date: dateFunc.toDate(cheque_pay_date),
            cheque_pay_write_date: dateFunc.toDate(cheque_pay_write_date),
            cheque_pay_price: numberFunc.decimalFix(cheque_pay_price, 2),
            cheque_pay_balance: numberFunc.decimalFix(cheque_pay_balance, 2),
            cheque_pay_remark,
            cheque_pay_crossed,
            cheque_pay_shipping,
            cheque_pay_shipping_date,
            cheque_pay_shipping_number,
            cheque_pay_shipping_bank_date,
            cheque_pay_shipping_bank_code,
            cheque_pay_shipping_bank_total,
            cheque_pay_shipping_value,
          })
        } else {
          this.setState({ cheque_validate: { status: 'INVALID', class: 'is-invalid', text: 'This cheque already exists.', } })
        }
      } else {
        this.setState({ cheque_validate: { status: 'VALID', class: 'is-valid', text: '', } })
      }
    } else {
      this.setState({ cheque_validate: { status: '', class: '', text: 'Please input cheque data', } })
    }
  }

  _handleClose = () => this.props.onClose()

  render() {
    const cheque_pay_crossed_option = [
      { label: 'ขีดคร่อม', value: "1", },
      { label: 'ไม่ขีดคร่อม', value: "0", },
    ]
    const cheque_pay_shipping_option = [
      { label: 'จัดส่ง', value: "1", },
      { label: 'มารับเอง', value: "0", },
    ]
    const bank_options = [{ label: '- เลือกธนาคาร -', value: '', }, ...this.state.banks.map(item => ({
      label: item.bank_name, value: item.bank_code,
    }))]

    const book_bank_options = [{ label: '- เลือกบัญชีธนาคาร -', value: '', }, ...this.state.book_banks.map(item => ({
      label: item.book_bank_name, value: item.book_bank_code,
    }))]

    const supplier_options = [{ label: '- เลือกผู้รับเช็ค -', value: '', }, ...this.state.suppliers.map(item => ({
      label: `[${item.supplier_code}] - ${item.supplier_name}`, value: item.supplier_code,
    }))]

    return (
      <Modal size="lg" centered isOpen={this.props.show} toggle={this._handleClose}>
        <ModalHeader toggle={this._handleClose}>
          {this.state.cheque_action === 'add' ? 'สร้าง' : 'รายละเอียด'}เช็คจ่าย
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <FormGroup>
                <label>วันที่สร้างเช็ค <font color="#F00"><b>*</b></font></label>
                <DatePicker
                  format={"DD/MM/YYYY"}
                  value={this.state.cheque_pay_date}
                  onChange={(e) => this.setState({ cheque_pay_date: e })}
                />
                <p className="text-muted">Example : 01/01/2020.</p>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label>ผู้รับเช็ค <font color="#F00"><b>*</b></font></label>
                <Input
                  type="text"
                  value={this.state.supplier_name}
                  onChange={(e) => this.setState({ supplier_name: e.target.value })}
                />
                <p className="text-muted">Example : Revel Soft.</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <label>วันที่เช็ค <font color="#F00"><b>*</b></font></label>
                <DatePicker
                  format={"DD/MM/YYYY"}
                  value={this.state.cheque_pay_write_date}
                  onChange={(e) => this.setState({ cheque_pay_write_date: e })}
                />
                <p className="text-muted">Example : 01/01/2020.</p>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <label>เลขที่เช็ค <font color="#F00"><b>*</b></font></label>
                <Input
                  type="text"
                  value={this.state.cheque_pay_number}
                  className={this.state.cheque_validate.class}
                  onChange={(e) => this.setState({ cheque_pay_number: e.target.value })}
                  onBlur={this._checkChequePayNumberBy}
                  autoComplete="off"
                  required
                />
                <p className="text-muted">Example : 2021801001.</p>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <label>ธนาคาร <font color="#F00"><b>*</b></font></label>
                <Select
                  options={bank_options}
                  value={this.state.bank_code}
                  onChange={(e) => this.setState({ bank_code: e }, () => this._checkChequePayNumberBy())}
                />
                <p className="text-muted">Example : BKK.</p>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <label>จ่ายจากบัญชี <font color="#F00"><b>*</b></font></label>
                <Select
                  options={book_bank_options}
                  value={this.state.book_bank_code}
                  onChange={(e) => this.setState({ book_bank_code: e })}
                />
                <p className="text-muted">Example : บัญชีกระแสรายวัน.</p>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <label>จำนวนเงิน <font color="#F00"><b>*</b></font></label>
                <Input
                  type="text"
                  className="float text-right"
                  value={this.state.cheque_pay_price}
                  onChange={(e) => handleFunc.inputFilter(e) && this.setState({ cheque_pay_price: e.target.value })}
                  autoComplete="off"
                />
                <p className="text-muted">Example : 1000.</p>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <label>ขีดคร่อม <font color="#F00"><b>*</b></font></label>
                <Select
                  options={cheque_pay_crossed_option}
                  value={this.state.cheque_pay_crossed}
                  onChange={(e) => this.setState({ cheque_pay_crossed: e })}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={3}>
              <FormGroup>
                <label>การจัดส่ง <font color="#F00"><b>*</b></font></label>
                <Select
                  options={cheque_pay_shipping_option}
                  value={this.state.cheque_pay_shipping}
                  onChange={(e) => this.setState({ cheque_pay_shipping: e })}
                />
              </FormGroup>
            </Col>
          </Row>
          {this.state.cheque_pay_shipping == "0" ?
            <Row>
              <Col md={3}>
                <FormGroup>
                  <label>วันที่มารับเช็ค <font color="#F00"><b>*</b></font></label>
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    value={this.state.cheque_pay_shipping_date}
                    onChange={(e) => this.setState({ cheque_pay_shipping_date: e })}
                  />
                  <p className="text-muted">Example : 01/01/2020.</p>
                </FormGroup>
              </Col>
            </Row>
            :
            <Row>
              <Col md={3}>
                <FormGroup>
                  <label>จ่ายค่าส่งแล้ว </label>
                  <Input
                    type="text"
                    value={this.state.cheque_pay_shipping_value}
                    onChange={(e) => this.setState({ cheque_pay_shipping_value: e.target.value })}
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <label>เงินสดผู้รับ </label>
                  <Input
                    type="text"
                    value={this.state.cheque_pay_shipping_bank_total}
                    onChange={(e) => this.setState({ cheque_pay_shipping_bank_total: e.target.value })}
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <label>เงินโอนธนาคาร/วัน/เวลา </label>
                  <Select
                    options={book_bank_options}
                    value={this.state.cheque_pay_shipping_bank_code}
                    onChange={(e) => this.setState({ cheque_pay_shipping_bank_code: e })}
                  />
                  <DatePicker
                    value={this.state.cheque_pay_shipping_bank_date}
                    onChange={(e) => this.setState({ cheque_pay_shipping_bank_date: e })}
                    format={"YYYY-MM-DD HH:mm"}
                    showTime
                  />
                  <p className="text-muted">Example : 01/01/2020.</p>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  <label>วันที่จัดส่ง </label>
                  <DatePicker
                    format={"DD/MM/YYYY"}
                    value={this.state.cheque_pay_shipping_date}
                    onChange={(e) => this.setState({ cheque_pay_shipping_date: e })}
                  />
                  <p className="text-muted">Example : 01/01/2020.</p>
                </FormGroup>
              </Col>
              <Col md={9}>
                <FormGroup>
                  <label>เลขที่ใบขนส่ง </label>
                  <Input
                    type="text"
                    value={this.state.cheque_pay_shipping_number}
                    onChange={(e) => this.setState({ cheque_pay_shipping_number: e.target.value })}
                    autoComplete="off"
                  />
                </FormGroup>
              </Col>
            </Row>
          }
          <FormGroup>
            <label>หมายเหตุ</label>
            <Input
              type="textarea"
              value={this.state.cheque_pay_remark}
              onChange={(e) => this.setState({ cheque_pay_remark: e.target.value })}
              autoComplete="off"
            />
            <p className="text-muted">Example : -.</p>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="primary" onClick={this._handleSave}>บันทึก</Button>
          <Button type="button" color="danger" onClick={this._resetState}>ล้างข้อมูล</Button>
          <Button type="button" onClick={this._handleClose}>ยกเลิก</Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default ChequePayModal